import { Stack } from "@mui/material"
import Box from "@mui/material/Box"

import AppAlert from "@components/app_alert"
import { LeftNavigationContextProvider } from "@contexts/left_navigation_context"
import NavigationPanel from "@layouts/main_layout/sub_components/navigation_panel"

import ExpiredTokenWarning from "@components/dialogs/expired_token"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import styles from "./styles"

export default function BaseLayout({
  children,
  bgColor
}: {
  children: JSX.Element | JSX.Element[]
  bgColor?: "primary" | "secondary"
}) {
  const location = useLocation()

  const [showInvalidTokenModal, setShowInvalidTokenModal] = useState(false)

  useEffect(() => {
    if (location.pathname.startsWith("/public")) {
      return
    }

    const jwt = localStorage.getItem("authToken")
    if (jwt && jwt.trim().length >= 3) {
      return
    }
    const oldLang = localStorage.getItem("i18nextLng") || "en"
    localStorage.clear()
    localStorage.setItem("i18nextLng", oldLang)
    const currentUrl = window.location.pathname + window.location.search
    const loginUrl = `/public/login?redirectUrl=${encodeURIComponent(currentUrl)}`
    window.location.replace(loginUrl)
  }, [location])

  useEffect(() => {
    // when token is invalid, trigger the event
    const handler = () => setShowInvalidTokenModal(true)
    window.addEventListener("invalidToken", handler)
    return () => {
      window.removeEventListener("invalidToken", handler)
    }
  }, [])

  return (
    <Box sx={styles.container(bgColor)}>
      {showInvalidTokenModal && <ExpiredTokenWarning />}
      <LeftNavigationContextProvider>
        <NavigationPanel />
      </LeftNavigationContextProvider>
      <Stack width={"100%"} height={"100"}>
        <AppAlert />
        {children}
      </Stack>
    </Box>
  )
}
